import React from 'react';
import Link from 'components_library/atoms/Link/Link';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import s from './PageNavigation.scss';

const getPageNumbers = (totalStories, storiesPerPage, currentPage) => {
  // Calculate the total number of pages
  const totalPages = Math.ceil(totalStories / storiesPerPage);

  if (currentPage > totalPages) {
    return [];
  }

  // Determine the starting page number for the array of 5 page numbers
  let startPage = currentPage;
  const endPage = Math.min(totalPages, startPage + 4);

  // Adjust the starting page number if there are not enough pages to display
  if (endPage - startPage < 4) {
    startPage = Math.max(1, endPage - 4);
  }

  const pageNumbers = Array.from(
    { length: Math.min(5, totalPages) },
    (_, index) => startPage + index,
  );

  return pageNumbers;
};

const PageNavigation = props => {
  const {
    currentPage = 1,
    totalStories,
    storiesPerPage,
    location,
    isMobile,
    gaType,
  } = props;
  if (!(totalStories && storiesPerPage && location)) {
    return null;
  }

  const totalPages = Math.ceil(totalStories / storiesPerPage);
  const pages = getPageNumbers(totalStories, storiesPerPage, currentPage);

  if (!(Array.isArray(pages) && pages.length && pages.length > 0)) {
    return null;
  }

  const sendGAOnPageClick = (category, clickedPage) => {
    if (clickedPage) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: gaType,
        category,
        label: typeof window === 'object' ? window?.location?.href : location,
        page_no: clickedPage,
      });
    }
  };

  return (
    <div className={`${isMobile ? s.mobileWrapper : ''} ${s.paginationWrap}`}>
      <Link
        to={`${location}/${currentPage - 1}`}
        className={`${s.arrowBtn}  ${!(currentPage > 1) ? s.disabled : ''} ${
          s.prevButton
        }`}
        onClick={() => {
          sendGAOnPageClick('previous_page', `${location}/${currentPage - 1}`);
        }}
      />
      <ul>
        {pages.map(page => (
          <li>
            <Link
              className={page === currentPage ? s.selected : ''}
              to={`${location}/${page}`}
              onClick={() => {
                sendGAOnPageClick('page_index', `${location}/${page}`);
              }}
            >
              {page}
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to={`${location}/${currentPage + 1}`}
        className={`${s.arrowBtn} ${s.nextButton} ${
          !(currentPage + 1 <= totalPages) ? s.disabled : ''
        }`}
        onClick={() => {
          sendGAOnPageClick('next_page', `${location}/${currentPage + 1}`);
        }}
      />
    </div>
  );
};

export default PageNavigation;
